import React from "react"
import { Link } from "gatsby"
import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import Button from "@material-ui/core/Button"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"

// import withDrupalOauthConsumer from "../drupal-oauth/withDrupalOauthConsumer"

export const isBrowser = () => typeof window !== "undefined"

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}))


function Navigation(props) {
  const classes = useStyles()
  let organization ='';
  organization = (isBrowser() && window.localStorage.getItem("organization") ? window.localStorage['organization'] : {})

  return (
    <AppBar position="static" className={classes.root}>
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          {props.siteTitle}
        </Typography>
        <div>
          <Button
            component={Link}
            to={"/?org="+organization}
            color="inherit"
          >
            New Check-In
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  )
}

export default Navigation
